import { Snowflake } from 'lucide-react';
import { Label } from '@/components/atoms/texts/label';
import { Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from '@/components/ui/tooltip';
import { formatHoldDate } from '@/utils/interestsHolds';

export function InterestsHoldPeriod({ hold }) {
    return (
        <span className="flex items-center gap-betweenText">
            <Label fontWeight="semibold">{formatHoldDate(hold.startDate)}</Label>
            <Label message="consultants.statement.interestsHolds.to" />
            {hold.endDate
                ? <Label fontWeight="semibold">{formatHoldDate(hold.endDate)}</Label>
                : <Label fontWeight="semibold" message="consultants.statement.interestsHolds.indefinite" />}
        </span>
    );
}

export default function InterestsHoldIcon({ holds = [], onClick, className = 'h-4 w-4' }) {
    if (!holds.length) return null;

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span
                    className={`inline-flex items-center text-informative-foreground ${onClick ? 'cursor-pointer' : 'cursor-default'}`}
                    onClick={onClick ? (e) => { e.stopPropagation(); onClick(holds[0]); } : undefined}
                >
                    <Snowflake className={className} />
                </span>
            </TooltipTrigger>
            <TooltipPortal>
                <TooltipContent>
                    <div className="flex flex-col gap-betweenText">
                        <Label fontWeight="bold" message="consultants.statement.interestsHolds.frozenDay" />
                        {holds.map((hold) => (
                            <div key={hold.uuid} className="flex flex-col">
                                <InterestsHoldPeriod hold={hold} />
                                {hold.comment && <Label size="small" color="disabled">{hold.comment}</Label>}
                            </div>
                        ))}
                        {onClick && <Label size="small" color="disabled" message="consultants.statement.interestsHolds.clickToEdit" />}
                    </div>
                </TooltipContent>
            </TooltipPortal>
        </Tooltip>
    );
}
